import { render, staticRenderFns } from "./PersonalCompany.vue?vue&type=template&id=0cf704b3&scoped=true"
import script from "./PersonalCompany.vue?vue&type=script&lang=js"
export * from "./PersonalCompany.vue?vue&type=script&lang=js"
import style0 from "./PersonalCompany.vue?vue&type=style&index=0&id=0cf704b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf704b3",
  null
  
)

export default component.exports